import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import { decamelize } from './util';

    export default class HtsOutput extends Component {    
        constructor(props) {
            super(props)
            this.resultData = this.props.qryOutput.responseParams.htsList;
        }
   
    render(){    
        return (
            <div id={`${this.props.qryInput.qryType.toLowerCase()}Output`} className={`outputData ${this.props.qryInput.qryType.toLowerCase()}Output`}>
                {
                    this.resultData?this.resultData.map((htsItem, index)=>{
                        return (
                                    <React.Fragment><Grid className={`primaryOutput`}>  
                                    {
                                        Object.keys(htsItem).map((item)=>{
                                            if(item.trim() && item!=='detail' && item!=='tradeProgramDetails' && item!=='effectiveStartDate' && item!=='effectiveEndDate'){
                                                return (
                                                    <Grid.Row className={`outputList-row`} columns={3}>
                                                        <Grid.Column className="keyName" width={5}>{decamelize(item)}</Grid.Column>
                                                        <Grid.Column width={1}></Grid.Column>
                                                        <Grid.Column className="keyValue" width={10}>{this.resultData[index][item]}{item=="userFeeSpecificRate"?"%":""}</Grid.Column>
                                                    </Grid.Row>
                                                )
                                            } 
                                        })
                                    }
                                </Grid>
                                <Grid className={`primaryOutput`} columns={3}>
                                    {
                                        htsItem.detail && htsItem.detail.records && htsItem.detail.records.map((_item)=>(
                                            <React.Fragment>
                                                <Grid.Row className={`outputList-row blueBorder bottom ${this.props.qryInput.qryType}`} columns={1}>
                                                    <Grid.Column className="keyValue cr-heading" width={10}>{_item.name}</Grid.Column>
                                                </Grid.Row>
                                                {
                                                    _item.values && _item.values.map((__item)=>(
                                                        <Grid.Row className={`outputList-row`}>
                                                            <Grid.Column className="keyName" width={5}>{decamelize(__item.key)}</Grid.Column>
                                                            <Grid.Column width={1}></Grid.Column>
                                                            <Grid.Column className="keyValue" width={10}>{__item.value}{__item.key=="userFeeSpecificRate"?"%":""}</Grid.Column>
                                                        </Grid.Row>
                                                    ))
                                                }
                                            </React.Fragment>
                                        ))  
                                    } 
                                </Grid> </React.Fragment>
                        );
                    }) 
                    :<div>
                        {
                            (this.props.qryInput && this.props.qryInput.qryType === 'HTS') && `No data for HTS query....`
                        }
                    </div>
                }
            </div>
        )
    }    
}
